// prettier-ignore
(window as any).global = window;
import { initFederation } from '@angular-architects/native-federation';

// The manifest path is imported from a dedicated file (not from environment.ts)
// because initFederation() MUST run before any shared federation module is loaded.
// environment.ts imports @share_it/foundation-core (a shared module), which would
// break the bootstrap if imported before federation is initialized.
import { federationManifestPath } from './environments/federation-manifest-path';

initFederation(federationManifestPath)
  .catch((err) => console.error(err))
  .then((_) => import('./bootstrap'))
  .catch((err) => console.error(err));
